import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";

const Holder = styled.div`
  color: black;
`;

const ArticleGrid = styled.div`

  @media (${(props) => props.theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: 2fr 3fr;
  }
`;

const ImageHolder = styled.div`
  color: #404040;
  
  p {
    ${(props) => props.theme.fluidType(-2)}
  }
  
  @media (${(props) => props.theme.breakpoints.md}) {
    width: 80%;
  }

`;

const ArticleBody = styled.div`
  ${(props) => props.theme.fluidType(1)}
  p {
    margin-top: 0;
  }

  @media (${(props) => props.theme.breakpoints.md}) {
    padding-left: 0.5rem;
    ${(props) => props.theme.fluidType(0.5)}
  }
  
`;

const Heading = styled.div`
  color: #FF00FF;
  font-family: "Universal Sans", sans-serif;
  font-weight: bold;
`;

const Text = styled.div`
  font-family: "Roboto Serif", serif;
`;

const SliceTextBlockImage = ({ slice }) => {
  const heading = slice.primary.text_heading.text;
  const text = slice.primary.text.richText;
  const image = slice.primary.image.gatsbyImageData;
  const alt = slice.primary.image.alt;
  const caption = slice.primary.caption.richText;

  return (
    <Holder>
        <ArticleGrid>
          <ImageHolder>
            <GatsbyImage alt={alt || ""} image={image} />
            <PrismicRichText field={caption} />
          </ImageHolder>
          <ArticleBody>
            <Heading>
              <p>{heading}</p>
            </Heading>
            <Text>
              <PrismicRichText field={text} />
            </Text>
          </ArticleBody>
        </ArticleGrid>
    </Holder>
  );
};

SliceTextBlockImage.propTypes = {
  slice: PropTypes.object.isRequired,
};

export default SliceTextBlockImage;

export const query = graphql`
  fragment SliceTextBlockImage on PrismicPerspectiveDataBodyTextBlockImage {
    id
    slice_type
      primary {
        text_heading {
          text
          richText
        }
        text {
          richText
        }
        image {
          gatsbyImageData(placeholder: BLURRED)
          url
          alt
        }
        caption {
          richText
        }
      }
  }
`;